<template>
    <modal
        :active="active"
        :large="true"
        :title="title()"
        @closed="$emit('closed', true)"
    >
        <List
            table-classes="table is-fullwidth"
            :columns="columns"
            :data="projects"
            :page-length="10"
            :rows-clickable="true"
            :default-order="{ col: 'id', dir: 'desc' }"
            @rowClicked="onRowClicked"
        />

        <template v-slot:footer>
            <div class="footer-spacer">
                <div>
                    <button class="button is-default" @click="$emit('closed', true)">Luk</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import humanDate from '../../../filters/humanDate';
import List from "@/elements/list";

export default {
    components: {
        Modal,
        List,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            projects: [],
            columns: [
                { 
                    name: 'id', 
                    title: 'Sagsnr.',
                    template: (row) => `#${row.id}` },
                { 
                    name: 'created_at', 
                    title: 'Dato', 
                    width: 20, 
                    template: (row) => humanDate(row.created_at)
                },
                {
                    name: 'customer',
                    title: 'Kunde',
                    template: (row) => row.customer.name,
                    search: (row) => row.customer.name,
                    sort: (row) => row.customer.name,
                },
                {
                    name: 'location',
                    title: 'Lokation',
                    template: (row) => this.projectLocation(row),
                    search: (row) => this.projectLocation(row),
                    sort: (row) => this.projectLocation(row),
                },
            ],
        }
    },
    watch: {
        active() {
            scrollLock(this.active);
            if (this.active) {
                this.loadProjects();
            } else {
                this.projects = [];
            }
        },
    },
    methods: {
        projectLocation(project) {
            if (project.location) {
                return project.location.name;
            }

            return project.ext_customer_name ? project.ext_customer_name : 'Ekstern lokation';
        },
        title() {
            return 'Sager med reservede varer'
        },
        loadProjects() {
            axios.get(`/api/items/${this.item.id}/projects`)
                .then(response => {
                    this.projects = response.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        onRowClicked(project) {
            scrollLock(false);
            this.$router.push({ name: 'project.edit', params: { id: project.id }})
        }
    },
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
}
</style>
